var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleIconBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 530.01 529.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #001efb;\n      }\n\n      .cls-2 {\n        isolation: isolate;\n      }\n\n      .cls-3 {\n        fill: none;\n        stroke: #fff;\n        stroke-miterlimit: 100;\n        stroke-width: 15px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1-2",
    "data-name": "Ellipse_1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 265,
    cy: 264.99,
    rx: 257.5,
    ry: 257.49
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 265,
    cy: 264.99,
    rx: 257.5,
    ry: 257.49
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleIconBlue);
export default __webpack_public_path__ + "static/media/CircleIcon_Blue.0f6bba16863acebe22d709fb92066b13.svg";
export { ForwardRef as ReactComponent };